import { createFileRoute } from '@tanstack/react-router'
import { ImportScreen } from '@/features/monday-import/routes/import-screen'

export const Route = createFileRoute('/settings/import')({ component: ImportScreen })
